(function ($) {
  productContentCarouselV1 = {
    formatter: function (context) {
      return $('.product-content-carousel-v1', context);
    },
    runOnceContexts: {
      contexts: [document],
      processedContexts: {
      },
      check: function (context) {
        if (context.jquery) {
          if (context.length > 1) {
            throw new Error('Attempted to do a context check against more than one context.');

            return;
          }
          context = context[0];
        }

        for (var i = 0; i < this.contexts.length; i += 1) {
          if (context === this.contexts[i]) {
            if (this.processedContexts[i]) {
              return false;
            } else {
              this.processedContexts[i] = true;

              return true;
            }
          }
        }

        return true;
      }
    }
  };

  Drupal.behaviors.productContentCarouselV1 = {
    get: function (key) {
      if (typeof productContentCarouselV1[key] === 'function') {
        return productContentCarouselV1[key].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        return productContentCarouselV1[key];
      }
    },

    set: function (key, val) {
      productContentCarouselV1[key] = val;
    },

    attach: function (context, settings) {
      if ($.isFunction($.fn.flexslider)) {
        var runOnceContexts = this.get('runOnceContexts');

        if (runOnceContexts.check(context)) { // if either we've not run this attach function against the document context or the context isn't document
          var self = this;
          var formatter = self.get('formatter', context);

          formatter.each(function () {
            var thisFormatter = $(this);
            // default 3-column
            var itemMargin = 20;
            var itemWidth = 300;
            var visibleCols = 3;

            // 5-column
            if (thisFormatter.hasClass('columns-5')) {
              itemMargin = 12;
              itemWidth = 180;
              visibleCols = 5;
            }

            // 1-column
            if (thisFormatter.hasClass('columns-1')) {
              itemMargin = 0;
              itemWidth = 950;
              visibleCols = 1;

              // 1-column mobile
              if ($('body').hasClass('device-mobile')) {
                itemWidth = 288;
              }
            }

            // 2-column - for now mobile only
            if ($('body').hasClass('device-mobile')) {
              // 2-column mobile
              if (thisFormatter.hasClass('columns-2')) {
                itemMargin = 0;
                itemWidth = 150;
                visibleCols = 2;
              }
            }

            // setup rows
            var items = thisFormatter.find('.slides > li');

            items.each(function (i) {
              $(this).prepend('<div class="number">' + (i + 1) + '</div>');
            });

            // build flexslider
            var flexsliderID = thisFormatter.children('.flexslider').attr('id');
            var flexslider = $('#' + flexsliderID);
            var slideshow = false;

            if (flexslider.hasClass('flexslider-slideshow')) {
              slideshow = true;
            }

            var flexsliderDir = flexslider.data('direction');
            var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;

            flexslider.flexslider({
              animation: 'slide',
              animationLoop: true,
              itemMargin: itemMargin,
              itemWidth: itemWidth,
              minItems: visibleCols,
              maxItems: visibleCols,
              move: 1,
              slideshow: slideshow,
              rtl: rtl
            });

            var lastTimeoutId;

            $(window).on('resize', function () {
              clearTimeout(lastTimeoutId);
              lastTimeoutId = setTimeout(function () {
                flexslider.flexslider('resize');
              }, 400);
            });
          });
        }
      }
    }
  };
})(jQuery);
